<template>
  <div>
    <h1 class="textcenter">公司详情</h1>
    <el-form ref="form" label-width="160px" class="detail">
      <el-form-item label="公司中文名" >
        <div>{{ form.chineseName }}</div>
      </el-form-item>
      <el-form-item label="公司英文名">
        <div>{{ form.englishName }}</div>
      </el-form-item>
      <el-form-item label="信用代码证">
        <div>{{ form.creditCodeCertificate }}</div>
      </el-form-item>
       <el-form-item label="营业执照">
        <div class="imgurl" @click="superbiggerImg(form.businessLicence)"><img :src="form.businessLicence" alt=""></div>
      </el-form-item>
       <el-form-item label="开户许可证">
        <div class="imgurl" @click="superbiggerImg(form.openingLicense)"><img :src="form.openingLicense" alt=""></div>
      </el-form-item>
      <el-form-item label="开户行">
        <div>{{ form.openingBank }}</div>
      </el-form-item>
      <el-form-item label="银行账号">
        <div>{{ form.bankAccount }}</div>
      </el-form-item>
      <el-form-item label="公司网页">
        <div>{{ form.indexPage }}</div>
      </el-form-item>
      <el-form-item label="公司类型名称">
        <div>{{ form.typeName }}</div>
      </el-form-item>
      <el-form-item label="品牌">
        <div>{{ form.brand }}</div>
      </el-form-item>
      <el-form-item label="公司星级 1-5">
        <div>{{ form.starLevel }}</div>
      </el-form-item>
      <el-form-item label="传真">
        <div>{{ form.fax }}</div>
      </el-form-item>
      <el-form-item label="状态">
        <div>{{ form.status === 1? '有效': '无效' }}</div>
      </el-form-item>
      <p>
        <el-form-item :label="n.typeName" v-for="n in form.addresses" :key="n.key" class="styls">
          <div class="contact">
            <span>{{ n.province }}</span>
            <span>{{ n.city }}</span>
            <span>{{n.address}}</span>
          </div>
        </el-form-item>
      </p>
      <p>
        <!-- <el-form-item label="联系人" v-for="n in form.contacts" :key="n.key" class="styls">
          <div class="contact">
            <span>{{n.name}}</span>
            <span>{{n.phone}}</span>
            <span>{{n.weChat}}</span>
            <span>{{n.email}}</span>
          </div>
        </el-form-item> -->
         <el-table
          :data="form.contacts"
          style="width: 100%">
           <el-table-column
            prop="name"
            label="姓名"
            width="180">
          </el-table-column>

           <el-table-column
            prop="positionName"
            label="职位"
            width="180">
          </el-table-column>
          
          <el-table-column
            prop="phone"
            label="手机"
            width="180">
          </el-table-column>

          <el-table-column
            prop="weChat"
            label="微信"
            width="180">
          </el-table-column>

          <el-table-column
            prop="qq"
            label="qq"
            width="180">
          </el-table-column>

          <el-table-column
            prop="email"
            label="邮箱"
            width="180">
          </el-table-column>

          <el-table-column
            prop="isMajor"
            label="是否为主要联系人"
            width="180">
          </el-table-column>
         

         </el-table>
    
      </p>
    </el-form>

    <el-dialog
      title="查看大图"
      :visible.sync="centerDialogVisible"
      width="80%"
      center>
          <img :src="biggerImg" alt="" style="width: 100%">
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">确定</el-button>
         </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      biggerImg: '',
      centerDialogVisible: false,
      form: {
        // chineseName: '公司中文名',
        // englishName: '公司英文名',
        // creditCodeCertificate: '信用代码证',
        // openingLicense: '开户许可证',
        // openingBank: '开户行',
        // bankAccount: '银行账号',
        // indexPage: '公司网页',
        // starLevel: '公司星级 1-5',
        // typeId: '公司类型id',
        // typeName: '公司类型名称',
        // status: '状态1 有效 2无效',
        // addresses: [ //  地址
        //   {
        //     id: 'id',
        //     address: 'address',
        //     typeId: 'typeId',
        //     typeName: 'typeName',
        //     companyId: 'companyId',
        //     status: 'status',
        //     createDate: 'createDate',
        //     createBy: 'createBy',
        //     updateDate: 'updateDate',
        //     updateBy: 'updateBy',
        //   }
        // ],
        // contacts: [ //  联系人
        //   {
        //     id: 'id',
        //     name: '名字',
        //     phone: '手机',
        //     weChat: '微信',
        //     email: '邮箱',
        //     positionId: '地址',
        //     companyId: '公司',
        //     status: '状态',
        //     createDate: '创建时间',
        //     createBy: '创建人',
        //     updateDate: '更新时间',
        //     updateBy: '更新人',
        //     isMajor: '是否重要'
        //   }
        // ],
        // brand: '',
      }
    }
  },
  mounted () {
    let obj = this.$router.app._route.query.name
    this.form = obj
  },
  methods: {
    superbiggerImg (img) {
      this.centerDialogVisible = true
      this.biggerImg  = img
    }
  }
}
</script>
<style lang="stylus" scoped>
.textcenter
  text-align center
  margin-bottom 30px
.detail>div
  // display inline-block
  // width 49%
  border-top 1px solid #ccc
  margin-bottom 0
  padding 10px 0
  // text-align center
.detail>div div
  font-size 14px
.detail>div:nth-of-type(odd)
  border-right 1px solid #ccc
.contact>span
  margin 0 10px
.styls
  padding 10px 0
  border-top 1px solid #ccc
  border-bottom 0
  margin-bottom 0
p:last-child
  border-bottom 1px solid #ccc
.imgurl
  img
    width 100px
</style>
